const NavDelivery = () => {
  return (
    <div id="delivery" className="nav-delivery-container">
      <p>RETIRO Y ENTREGA A DOMICILIO</p>
    </div>
  );
};

export default NavDelivery;
